import { useRoute } from 'vue-router'

/**
 * 获取当前语言
 * @returns 当前语言代码，默认返回 'zh'
 */
export const getCurrentLang = (): string => {
  const route = useRoute()
  return (route.params.lang as string) || 'zh'
}

/**
 * 构建带语言前缀的路径（仅用于前台页面）
 * @param path 原始路径
 * @returns 带语言前缀的完整路径
 */
export const buildPathWithLang = (path: string): string => {
  const lang = getCurrentLang()
  
  // 如果路径已经是完整路径（包含语言），直接返回
  if (path.startsWith(`/${lang}/`) || path === `/${lang}`) {
    return path
  }
  
  // 特殊处理首页
  if (path === '/') {
    return `/${lang}`
  }
  
  // 移除开头的斜杠，然后添加语言前缀
  const cleanPath = path.replace(/^\/+/, '')
  return `/${lang}/${cleanPath}`
}

/**
 * 在 Composition API 中使用的获取当前语言的 hook
 * @returns 响应式的当前语言和路径构建函数
 */
export const useCurrentLang = () => {
  const route = useRoute()
  return {
    currentLang: () => (route.params.lang as string) || 'zh',
    buildPath: (path: string) => {
      const lang = (route.params.lang as string) || 'zh'
      
      if (path.startsWith(`/${lang}/`) || path === `/${lang}`) {
        return path
      }
      
      if (path === '/') {
        return `/${lang}`
      }
      
      const cleanPath = path.replace(/^\/+/, '')
      return `/${lang}/${cleanPath}`
    }
  }
}